import './MechanicInfo.css'

interface MechanicInfoProps {
  mechanicName?: string | null
  companyName?: string | null
}

export default function MechanicInfo({ 
  mechanicName, 
  companyName
}: MechanicInfoProps) {
  // Если нет данных, не показываем компонент
  if (!mechanicName && !companyName) {
    return null
  }

  // Получаем инициалы из имени
  const getInitials = (name: string): string => {
    const parts = name.trim().split(' ')
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase()
    } else if (parts.length === 1) {
      return parts[0][0].toUpperCase()
    }
    return 'M'
  }

  const name = mechanicName || ''
  const company = companyName || ''
  const initials = name ? getInitials(name) : 'M'

  return (
    <div className="mechanic-info">
      {name && (
        <div className="mechanic-info__avatar">
          <span className="mechanic-info__initials">{initials}</span>
        </div>
      )}
      <div className="mechanic-info__text">
        {name && <h2 className="mechanic-info__name">{name}</h2>}
        {company && <p className="mechanic-info__company">{company}</p>}
      </div>
    </div>
  )
}
